<!-- This component is based on https://ob1.orange.fr/#example/alerte.html -->

<template>
  <p
    :class="['alert', alertType]"
    role="alert">
    <span
      class="alert-icon"
      aria-hidden="true" />
    <span class="ob1-alert-title">{{ message }}</span>
  </p>
</template>

<script>
import CONSTANTS from './Alert.constants'
const types = ['success', 'info', 'warning', 'danger']
export default {
  name: 'WptvAlert',
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: (value) => types.includes(value)
    }
  },
  computed: {
    alertType () {
      return CONSTANTS.TYPES[this.type.toUpperCase()]
    }
  }
}
</script>

<style scoped>

</style>
